import LocalParkingOutlinedIcon from '@mui/icons-material/LocalParkingOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import CardMembershipOutlinedIcon from '@mui/icons-material/CardMembershipOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import type { NavEntry, NavGroup, NavItem } from '@/navigation/navItems';
import { Perm } from '@/auth/permissions';
import { Modules } from '@/core/modules/moduleKeys';

const item = (label: string, path: string, icon: NavItem['icon']): NavItem => ({ label, path, icon, module: Modules.Parking, permission: Perm.Parking.View });

/**
 * The parking module's navigation: one Parking menu, grown phase by phase (operations, cashier,
 * commercial, finance and devices join the set-up). Shown only where the organisation has the module on.
 */
export const parkingNavEntries: NavEntry[] = [
  item('Overview', '/parking', DashboardOutlinedIcon),
  item('Operations', '/parking/operations', SwapHorizOutlinedIcon),
  item('Cashier', '/parking/cashier', PointOfSaleOutlinedIcon),
  item('Commercial', '/parking/commercial', CardMembershipOutlinedIcon),
  item('Devices', '/parking/devices', VideocamOutlinedIcon),
  { ...item('Finance', '/parking/finance', AccountBalanceOutlinedIcon), permission: Perm.Parking.Reports },
  item('Vehicles', '/parking/vehicles', DirectionsCarOutlinedIcon),
  item('Parking Settings', '/parking/settings', SettingsOutlinedIcon),
];

export const parkingNavGroup: NavGroup = {
  kind: 'group', key: 'parking', label: 'Parking', icon: LocalParkingOutlinedIcon, items: parkingNavEntries,
};
